'use client';
import { ProductsCarousel } from '../../components/homepage/products-carousel';
import { useRelatedProducts } from '@eliadmin/core/src/hooks/products/use-related-products';
import { RelatedProductsStatus } from '@eliadmin/core/src/components/product/detail/related-products-status';
export function ProductRelatedProducts({ slug }: { slug: string }) {
  const related = useRelatedProducts(slug);
  const products = related.products;
  if (!products.length && !related.isLoading && !related.isError) return null;
  return (
    <>
      {' '}
      {products.length > 0 && (
        <ProductsCarousel title="Podobné produkty" products={products} />
      )}{' '}
      <div className="mx-auto w-full max-w-screen-2xl px-4">
        <RelatedProductsStatus
          loading={related.isLoading}
          error={related.isError}
          retry={() => {
            void related.refetch();
          }}
        />
      </div>{' '}
    </>
  );
}
